<template>
  <b-card-text>
    <b-col
      cols="12"
      md="12"
    >
      <validation-provider
        #default="validationContext"
        name="Dado"
        :rules="{ required: false }"
      >
        <b-form-group
          label="Tipo da pesquisa"
          label-for="dado"
        >
          <v-select
            id="dado"
            v-model="tipoBuscaLocal"
            :options="tipoBuscaOptions"
            :reduce="val=>val.value"
          />
        </b-form-group>
        <span class="undermessage-error">
          {{ validationContext.errors[ 0 ] }}
        </span>
      </validation-provider>
    </b-col>

    <b-col
      cols="12"
      md="12"
    >
      <div class="form-group">
        <label>Cole os dados na área ou escreva separado por vírgula</label>
        <textarea
          id="textArea"
          v-model="dataExcel"
          class="form-control"
          rows="20"
          @paste="onPaste"
        />
      </div>
    </b-col>
  </b-card-text>
</template>

<script>

export default {
  name: 'BulkModal',
  props: {
    data: {
      type: undefined,
      required: true,
    },
    tipoBusca: {
      type: undefined,
      required: true,
    },
  },
  data() {
    return {
      dataExcel: this.data,
      tipoBuscaLocal: this.tipoBusca,
    }
  },
  watch: {
    dataExcel(newVal) {
      const transformed = newVal.replace(/\n/g, '//t')
      this.$emit('update:data', transformed)
    },
    tipoBuscaLocal(newVal) {
      this.$emit('update:tipoBusca', newVal)
    },
  },
  methods: {
    onPaste(event) {
      event.preventDefault()
      const clipboardData = event.clipboardData || window.clipboardData
      let pastedText = clipboardData.getData('text')
      pastedText = pastedText.trim().replace(/[\t\r\n]+/g, ',')
      this.dataExcel = pastedText
    },
  },
  setup() {
    const tipoBuscaOptions = [
      { label: 'CTE', value: 'cte' },
      { label: 'Shipment ID', value: 'shippmentId' },
      { label: 'Nota Fiscal', value: 'numeroNotaFiscal' },
      { label: 'Pedido', value: 'numeroPedido' },
    ]

    return {
      tipoBuscaOptions,
    }
  },
}
</script>

<style scoped>

</style>